import {Component, ViewChild, OnInit, ChangeDetectorRef, AfterViewInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalComponent} from '../../../../../modal/modal.component';
import {AnnouncementService} from '../../../../../shared/services/announcement.service';
import {SubmissionSearchUserInfoObject} from '../../../search-object';
import {Subscription} from 'rxjs';
import {SubmissionHistoryService} from '../../../../../shared/services/submission-history.service';
import {AnnouncementFormInt} from '../../interfaces/announcement';


@Component({
    selector: 'create_announcement',
    templateUrl: './create_announcement.component.html',
    styleUrls: ['./create_announcement.component.scss'],
    providers: [AnnouncementService]
})
export class CreateAnnouncement implements OnInit, AfterViewInit {

    private initial: AnnouncementFormInt;

    userInfo: SubmissionSearchUserInfoObject = new SubmissionSearchUserInfoObject();
    private        userInfoSubscription: Subscription;
    cancelTitle = 'Changes will not be saved';
    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly service: AnnouncementService,
        private submissionHistoryService: SubmissionHistoryService,
        private readonly cdr: ChangeDetectorRef
    ) {
    }

    ADMIN_ANNOUNCEMENTS_PAGE = '/admin/announcements';

    @ViewChild('cancelAnnouncement')
    public modal: ModalComponent;
    sourceModalContent: string;
    announcementIdRegex: RegExp = /^\d+$/;

    @ViewChild('announcement', {static: false}) announcement;

    ngOnInit(): void {
        document.title = 'Create New Announcement';
        this.userInfoSubscription = this.submissionHistoryService.currentUserInfo.subscribe(message => {this.userInfo = message});
        this.initial = Object.assign({}, this.model as AnnouncementFormInt);
    }

    ngAfterViewInit(): void {
        this.cdr.detectChanges();
    }

    public model: Object = {
        announcement: {
            announcementId: '',
            announcementTypeCde: '',
            announcementTitle: '',
            announcementTxt: '',
            effectiveDate: '',
            endDate: '',
            linkTxt: '',
            linkUrl: '',
            releaseNumber: ''
        },
        reportingCenters: []
    };

    public onSubmit () {
        const model = this.announcement.Form.value;
        this.service.prepareTime(model);
        this.service.createAnnouncement(model.announcement).subscribe(res => {
            const announcementId = this.announcementIdRegex.test(res.body) ? res.body : '0';
            if (announcementId !== '0') {
                model.announcement.reportingCenters.forEach(center => {
                    this.service.createMappingToReportingCenter(res.body, center).subscribe( () =>{
                        console.log(`Saved center ${center}`);
                    })
                });
            }
            this.router.navigateByUrl(this.ADMIN_ANNOUNCEMENTS_PAGE);
            },
            error => {
                if (error.status < 500) {
                    console.error('Errors saving announcement.');
                }
            });
    };

    public onCancel() {
        const form = this.announcement.Form;
        if (form.dirty) {
            this.modal.small(true);
            this.modal.open();
        } else {
            this.router.navigateByUrl(this.ADMIN_ANNOUNCEMENTS_PAGE);
        }
    };

    public cancelEditAnnouncement() {
        const initial = this.initial;
        this.initial = Object.assign({}, initial);
        this.model = initial;
        this.modal.close();
    }

    public redirectToAnnouncements() {
        this.router.navigateByUrl(this.ADMIN_ANNOUNCEMENTS_PAGE);
    }
}
